/**
 * SECTOR-PICKER-MODAL
 * Choose the account's industry sector (used for benchmark comparison). Standalone modal, used
 * only by the raw supervisor card (no other modal open at that point — see SectorGrid for the
 * client / connected-as-supervisor case, embedded inline in SupervisorUnmatchedQuestionsModal).
 * Also reused as-is by SupervisorAccountsWidget/SupervisorAccountsWithoutSectorWidget's account
 * edit flow (2026-09-15, Tom: "on a un genre de sectorPicker qu'on a fait pour l'éditeur de
 * template" — no need for a separate account-editing modal, sector is the only editable field
 * there since "taille" was dropped as dead weight). `title` lets that caller show the account
 * name instead of the generic default. `onReset` (2026-09-15, Tom: "j'aimerai un btn pour reset")
 * shows a "Réinitialiser" button in the footer, only when a sector is actually set — that
 * capability existed before via the account row's own "not defined" dropdown option, lost when
 * this modal replaced it, so it's restored here rather than in SectorGrid (TemplateBenchmarkSidebar
 * already has its own separate "Retirer" link outside the grid for the same reason).
 */
import { useTranslation } from "react-i18next"
import Modal from "@/components/modal"
import Button from "@/components/button"
import SectorGrid from "./SectorGrid"

interface Props {
  current?: string | null
  title?: string
  onClose: () => void
  onSelect: (sector: string) => void
  onReset?: () => void
}

function SectorPickerModal(props: Props) {
  const { t } = useTranslation()

  return (
    <Modal
      onClose={props.onClose}
      isCloseButtonVisible
      isLarge
      title={props.title ?? t("benchmark_editor_sector_modal_title")}
      footer={
        props.onReset && props.current ? (
          <Button onClick={props.onReset}>{t("benchmark_editor_sector_reset")}</Button>
        ) : undefined
      }>
      <SectorGrid current={props.current} onSelect={props.onSelect} />
    </Modal>
  )
}

export default SectorPickerModal
